import React from 'react';
import DeveloperInfo from './DeveloperInfo';
import './WelcomeScreen.css';

const WelcomeScreen = ({ onComplete }) => {
  return (
    <div className="welcome-screen">
      <div className="welcome-container">
        {/* Header with Logo */}
        <div className="welcome-header">
          <div className="logo-wrapper">
            <img src="/logo.jpeg" alt="شعار المدرسة" className="welcome-logo" />

          </div>
        </div>

        {/* Main Content */}
        <div className="welcome-content">
          <h2 className="welcome-subtitle">أهلًا ومرحبًا بكم في</h2>
          <h1 className="welcome-title">منصة المراجعات النهائية</h1>
          <p className="welcome-description">بمتوسطة وثانوية نخبة الشمال الأهلية</p>
        </div>

        {/* Start Button */}
        <div className="welcome-actions">
          <button className="start-button ripple-effect magnetic-button pulse-element" onClick={onComplete}>
            ابدأ
          </button>
        </div>

        {/* Footer */}
        <div className="welcome-footer">
          <p>مدير المدرسة: محمد نصر الدين</p>
        </div>
      </div>
      <DeveloperInfo />
    </div>
  );
};

export default WelcomeScreen;

